//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {},
  props: {},
  data: function data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted: function mounted() {},
  methods: {}
};